module.exports = __webpack_public_path__ + "img/堅持_四方連續_線稿_black.b622e5bb.png";